import React from 'react'
import UpcomingBooks from './UpcomingBooks'
import Todayoffers from './Todayoffers'
import PopularAuthors from './PopularAuthors'
import Testimonials from './Testimonials'
import Popular from './Popular'
import { Box, Container } from '@mui/material'
// import Hero from './Hero'
// import Filter from '../../common/Filter'
// import NewRelease from './NewRelease'
// import Combo from './Combo'
import useResponsive from '../../hooks/useResponsive'
import Filter from '../../common/Filter'
import Hero from './Hero'
import NewRelease from './NewRelease'
import Combo from './Combo'



const Home = () => {
    const { isSmallScreen } = useResponsive()
    return (
        <div>
            

            <Hero />
            <Popular />
                 
            <Container maxWidth='xl' sx={{ display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', gap: '15px' }}>
                <Box width={isSmallScreen ? '100%' : '25%'}>
                    <Filter />
                </Box>
                <Box width={isSmallScreen ? '100%' : '75%'}>
                    <NewRelease />
                    <Combo />
                </Box>
            </Container>
            <UpcomingBooks />
            <Todayoffers />
            <PopularAuthors />
            <Testimonials />
          
        </div>
    )
}

export default Home